import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import Text from '../Text';
import { Row, Column } from '../Layout/Grid';

import checklist from 'img/menu-icon-checklist.svg';
import bottles from 'img/menu-icon-bottles.svg';
import returned from 'img/menu-icon-returned.svg';
import megaphone from 'img/menu-icon-megaphone.svg';
import userIcon from 'img/menu-icon-user.svg';
import president from 'img/menu-icon-presidente.svg';
import noteCorrection from 'img/icon-correction.svg';
import legalDocuments from 'img/legal-documents.svg';
import papper from 'img/menu-icon-papper.svg';
import documentRegulatory from 'img/icon-documents-regulatory.svg';
import nutritionist from 'img/icon-talk-nutritionist.svg';
import iconFollowUpEntregue from 'img/icon-follow-entrega.svg';
import iconFollowUpNaoEntregue from 'img/icon-follow-nao-entregue.svg';

import {
  eventName,
  dashboardClienteAction,
  dashboardCustomerEvent
} from 'components/ApplicationInsights/eventNames';
import NoteCorrectionSlider from 'components/NoteCorrectionSlider';
import TrackingOrderSlider from 'components/TrackingOrderSlider';
import { useCustomEvent } from 'components/ApplicationInsights';
import SwitchComponent from 'components/SwitchComponent';
import TrackingSlider from 'components/TrackingSlider';
import { ContactPresident } from 'components/ContactPresident';
import InvoiceSlider from 'components/InvoiceSlider';
import ReportsSlider from 'components/ReportsSlider';
import BilletSlider from 'components/BilletSlider';
import XmlNfeSlider from 'components/XmlNfeSlider';
import { Visibility } from 'components/Visibility';
import FollowUpDelivered from 'components/FollowUpDeliverSlider/FollowUpDelivered';
import FollowUpNotDelivered from 'components/FollowUpDeliverSlider/FollowUpNotDelivered';
import Billet from './Billet';
import TrackingOrder from './TrackingOrder';
import Invoice from './Invoice';
import XmlInvoice from './XmlInvoice';
import Tracking from './Tracking';

import { IMenuItem, IMenuItems } from './interface';

import { SelectCustomerIdIsArray } from 'utils/SelectCustomerIdIsArray';
import { handleDispatchOpenSlider } from 'utils/Slider';
import { simulateMouseClick } from 'utils/SimulateMouseClick';

import { ICustomerRole } from 'models/CustomerRole';
import { EnumCategories } from 'models/Ticket';

import { useMenuChatContext } from 'contexts/MenuChat';

import './styles.scss';
import { sendUserDataToAnalytics } from 'utils/gtm';

export const MenuItem: React.FC<IMenuItem> = (props) => {
  const componentName = `Menu Dash Cliente`;
  const trackMenuClick = useCustomEvent(componentName, eventName.DASHBOARD_CLIENTE);
  const { icon, title, subtitle, onClick, trackName, disabled = false, id } = props;

  async function clickMenu() {
    if (trackName) {
      trackMenuClick({ item: trackName });
    }

    if (onClick) {
      onClick();
    }
  }

  return (
    <button
      className="d-flex menu-item first flex-column align-center justify-center pb-2 pt-3 bg-white shadow-1"
      onClick={clickMenu}
      disabled={disabled}
      id={id}
    >
      {icon && <img src={icon} alt="" />}
      <Column>
        <Text
          size={13}
          className="mt-2 text-center color-blue-gray text-wrap font-bold"
        >
          {title}
        </Text>
        <Text
          size={13}
          className="text-center color-blue-gray text-wrap font-bold"
        >
          {subtitle}
        </Text>
      </Column>
    </button>
  );
};

export const MenuItems: React.FC<IMenuItems> = (props) => {
  const { className } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.user);
  const enterpriseVips = useSelector((state: RootState) => state.enterpriseVips);

  const [isEnterPriseVip, setIsEnterPriseVip] = useState<boolean>(false);

  const { setNutritionist } = useMenuChatContext();

  useEffect(() => {
    if (user?.selectedCustomerId && enterpriseVips) {

      const findCustomer = user?.customersRoles?.filter((c: ICustomerRole) =>
        user?.selectedCustomerId?.includes(c.customerId!)
      );

      const enterPriseVip: any = findCustomer?.find((c: ICustomerRole) =>
        enterpriseVips.includes(c?.documentNumber!)
      );

      setIsEnterPriseVip(enterPriseVip);
    }
  }, [user, enterpriseVips]);

  const openChatBot = () => {
    const chatBot = document.getElementById("chat-bot");

    if (chatBot != null) {
      simulateMouseClick(chatBot);
    }
  };

  const OpenMenuChat = () => {
    setNutritionist("NUTRICIONISTA");
    openChatBot();
    sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_FALECOMNUTRICIONISTA);
  };

  const sendDataLayer = (eventName: string) => {
    sendUserDataToAnalytics(eventName, user!);
  };

  return (
    <>
      <Row className={`menu-main-grid mt-3 ${className ?? ''}`}>
        <Billet
          itemComponent={MenuItem}
          clickAction={() => {
            handleDispatchOpenSlider({
              title: "2ª Via de Boleto",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: BilletSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_SEGUNDAVIABOLETO);
          }}
        />
        <TrackingOrder
          itemComponent={MenuItem}
          clickAction={() => {
            handleDispatchOpenSlider({
              title: "Tracking do Pedido",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: TrackingOrderSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_TRACKINGPEDIDO);
          }}
        />
        <Invoice
          itemComponent={MenuItem}
          clickAction={() => {
            handleDispatchOpenSlider({
              title: "Notas Fiscais",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: InvoiceSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_NOTASFISCAIS);
          }}
        />
        <XmlInvoice
          itemComponent={MenuItem}
          clickAction={() => {
            handleDispatchOpenSlider({
              title: "XML NFe",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: XmlNfeSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_XMLNFE);
          }}
        />
        <MenuItem
          id="data-reports-menu-item"
          title="FICHAS &"
          subtitle="LAUDOS"
          icon={checklist}
          trackName={dashboardClienteAction.DASHCLIENTE_LAUDOSFICHAS}
          onClick={() => {
            handleDispatchOpenSlider({
              title: "Fichas & Laudos",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: ReportsSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_LAUDOSFICHAS);
          }}
        />
        <Tracking
          itemComponent={MenuItem}
          clickAction={() => {
            handleDispatchOpenSlider({
              title: "Comprovante de entrega",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: TrackingSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_COMPROVANTEENTREGA);
          }}
        />
        <MenuItem
          id="note-correction-menu-item"
          title="CORREÇÃO DA"
          subtitle="NOTA FISCAL"
          icon={noteCorrection}
          trackName={dashboardClienteAction.DASHCLIENTE_NOTACORRECAO}
          onClick={() => {
            handleDispatchOpenSlider({
              title: "Correção da nota fiscal",
              subtitle: "Utilize os campos abaixo para localizar o seu pedido.",
              show: true,
              content: NoteCorrectionSlider,
              dispatch
            });

            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_NOTACORRECAO);
          }}
        />
        <SwitchComponent roles={['administrator']} type={['customer']}>
          <MenuItem
            id="manage-user-customer-menu-item"
            title="GERENCIAR"
            subtitle="USUÁRIOS"
            icon={userIcon}
            trackName={dashboardClienteAction.DASHCLIENTE_GERENCIARUSUARIOS}
            onClick={() => {
              navigate('/gerenciar-usuarios');
              sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_GERENCIARUSUARIOS);
            }}
          />
        </SwitchComponent>
        <SwitchComponent
          roles={['administrator', 'member']}
          type={['employee']}
        >
          <MenuItem
            id="manage-user-employee-menu-item"
            title="GERENCIAR"
            subtitle="USUÁRIOS"
            icon={user}
            trackName={dashboardClienteAction.DASHCLIENTE_GERENCIARUSUARIOS}
            onClick={() => {
              navigate('/gerenciar-usuarios');
              sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_GERENCIARUSUARIOS);
            }}
          />
        </SwitchComponent>
        <MenuItem
          id="request-return-menu-item"
          title="SOLICITAR"
          subtitle="DEVOLUÇÃO"
          icon={returned}
          trackName={dashboardClienteAction.DASHCLIENTE_SOLICITARDEVOLUCAO}
          onClick={() => {
            !SelectCustomerIdIsArray() &&
              navigate('/abrir-protocolo', {
                state: {
                  protocolCategory: EnumCategories.DEVOLUCAO,
                }
              });

            !SelectCustomerIdIsArray() &&
              sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_SOLICITARDEVOLUCAO);
          }}
        />
        <MenuItem
          id="technical-complaint-menu-item"
          title="RECLAMAÇÃO"
          subtitle="TÉCNICA"
          icon={megaphone}
          trackName={dashboardClienteAction.DASHCLIENTE_RECLAMACAOTECNICA}
          onClick={() => {
            !SelectCustomerIdIsArray() &&
              navigate('/abrir-protocolo', {
                state: {
                  protocolCategory: EnumCategories.RECLAMACAO_TECNICA,
                }
              });

            !SelectCustomerIdIsArray() &&
              sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_RECLAMACAOTECNICA);
          }}
        />
        <MenuItem
          id="product-consultation-menu-item"
          title="CONSULTA"
          subtitle="DE PRODUTOS"
          icon={bottles}
          trackName={dashboardClienteAction.DASHCLIENTE_CONSULTAPRODUTOS}
          onClick={() => {
            navigate('/produtos');
            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_CONSULTAPRODUTOS);
          }}
        />
        <MenuItem
          id="business-policies-menu-item"
          title="POLÍTICAS"
          subtitle="DE NEGÓCIO"
          icon={papper}
          trackName={dashboardClienteAction.DASHCLIENTE_POLITICASNEGOCIO}
          onClick={() => {
            !SelectCustomerIdIsArray() && navigate('/politicas', { state: { politicBusiness: true } });
            !SelectCustomerIdIsArray() && sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_POLITICASNEGOCIO);
          }}
        />
        <MenuItem
          id="legal-documents-menu-item"
          title="DOCUMENTOS"
          subtitle="LEGAIS"
          icon={legalDocuments}
          trackName={dashboardClienteAction.DASHCLIENTE_DOCUMENTOSLEGAIS}
          onClick={() => {
            !SelectCustomerIdIsArray() && navigate('/dados-cliente');
            !SelectCustomerIdIsArray() && sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_DOCUMENTOSLEGAIS);
          }}
        />
        <MenuItem
          id="regulatory-documents-menu-item"
          title="DOCUMENTOS"
          subtitle="LEGAIS VIVEO"
          icon={documentRegulatory}
          trackName={dashboardClienteAction.DASHCLIENTE_DOCUMENTOSREGULATORIOS}
          onClick={() => {
            !SelectCustomerIdIsArray() && navigate('/politicas', { state: { regulatoryDocument: true } });
            !SelectCustomerIdIsArray() && sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_DOCUMENTOSREGULATORIOS);
          }}
        />
        <MenuItem
          id="contact-nutritionist-menu-item"
          title="FALE COM A"
          subtitle="NUTRICIONISTA"
          icon={nutritionist}
          trackName={dashboardClienteAction.DASHCLIENTE_FALECOMNUTRICIONISTA}
          onClick={() => OpenMenuChat()}
        />
        <Visibility visible={isEnterPriseVip}>
          <MenuItem
            id="speak-with-president-menu-item"
            title="FALAR COM"
            subtitle="PRESIDENTE"
            icon={president}
            trackName={dashboardClienteAction.DASHCLIENTE_FALARCOMPRESIDENTE}
            onClick={() => {
              !SelectCustomerIdIsArray() &&
                handleDispatchOpenSlider({
                  title: "Fale com o presidente",
                  subtitle:
                    'Por ter um compromisso permanente com sua satisfação, o ' +
                    'Grupo VIVEO disponibiliza este espaço para você entrar em ' +
                    'contato direto com a nossa presidência. Solicitamos a ' +
                    'gentileza de preencher todos os campos para facilitar ' +
                    'nosso contato.',
                  show: true,
                  content: ContactPresident,
                  dispatch
                });

              !SelectCustomerIdIsArray() &&
                sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_FALARCOMPRESIDENTE);
            }}
          />
        </Visibility>
        <MenuItem
          id="delivery-follow-up-menu-item"
          title="FOLLOW-UP"
          subtitle="DE ENTREGAS"
          icon={iconFollowUpEntregue}
          trackName={dashboardClienteAction.DASHCLIENTE_FOLLOWUPENTREGAS}
          onClick={() => {
            handleDispatchOpenSlider({
              title: "Follow-up de Entregas",
              subtitle: "Utilize os campos abaixo para gerar o relatório.",
              show: true,
              content: FollowUpDelivered,
              dispatch
            });
            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_FOLLOWUPENTREGAS);
          }}
        />
        <MenuItem
          id="non-delivery-follow-up-menu-item"
          title="FOLLOW-UP"
          subtitle="NÃO ENTREGUES"
          icon={iconFollowUpNaoEntregue}
          trackName={dashboardClienteAction.DASHCLIENTE_FOLLOWUPNAOENTREGUE}
          onClick={() => {
            handleDispatchOpenSlider({
              title: "Follow-up Não Entregues",
              subtitle: "Utilize os campos abaixo para gerar o relatório.",
              show: true,
              content: FollowUpNotDelivered,
              dispatch
            });
            sendDataLayer(dashboardCustomerEvent.DASHCLIENTE_FOLLOWUPNAOENTREGUE);
          }}
        />

      </Row>
    </>
  );
};
